<template>
 <div class="radio-group">
    <div class="radio-btn-container" v-for="item in items" :key="item.id" @click="checked = item.id">
      <input type="checkbox" :checked="checked === item.id">
      <label :for="item.id">{{ item.label }}</label>
      <span class="checkmark"></span>
    </div>
 </div>
</template>

<script>
export default {
  name: 't-radio-group',
  props: {
    value: [String, Number],
    items: Array
  },
  computed: {
    checked: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.radio-btn-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.radio-btn-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  label {
   cursor: pointer;
   font-weight: normal;
   color: var(--on-surface);
   font-size: 16px;
  }
}

.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  border: 2px solid var(--primary-dark);
  border-radius: 50%;
}

.checkmark:after {
  content: "";
  position: absolute;
  height: 23px;
  width: 23px;
  border-radius: 50%;
}

.radio-btn-container:hover .checkmark:after {
  background-color: var(--primary);
  opacity: 0.5;
}

.radio-btn-container input:checked ~ .checkmark {
  background-color: var(--primary);
}
</style>
